import circleIcon from "@/assets/leaflet/circleIcon";
import { USER_COLORS } from "@/utils/constants/colors";
import L, { LatLngExpression, LatLngTuple, LeafletMouseEvent } from "leaflet";
import { FC, useEffect, useState } from "react";
import { Marker, Polyline, useMap } from "react-leaflet";

interface TraceEditProps {
  // eslint-disable-next-line no-unused-vars
  onDraw: (point: LatLngTuple) => void;
}

const TraceEdit: FC<TraceEditProps> = ({ onDraw }) => {
  const map = useMap();
  const [tracePoints, setTracePoints] = useState<LatLngExpression[]>([]);

  const formattedTraceHeadIcon = new L.Icon({
    iconUrl: circleIcon(USER_COLORS.grey.grey4),
    iconSize: [22, 22],
  });

  useEffect(() => {
    const mouseClickListener = (e: LeafletMouseEvent) => {
      if (
        e.originalEvent.target === map.getContainer() ||
        (e.originalEvent.target as HTMLElement).classList.contains("leaflet-interactive")
      ) {
        onDraw([e.latlng.lat, e.latlng.lng]);
        setTracePoints([...tracePoints, [e.latlng.lat, e.latlng.lng]]);
      }
    };

    map.addEventListener("click", mouseClickListener);

    return () => {
      map.removeEventListener("click", mouseClickListener);
    };
  }, [tracePoints]);

  if (tracePoints.length == 1) {
    return <Marker position={tracePoints[0]} icon={formattedTraceHeadIcon} />;
  }

  return <Polyline positions={tracePoints} pathOptions={{ color: USER_COLORS.grey.grey4 }} dashArray={[10, 10]} />;
};

export default TraceEdit;
